<template>
    <carousel classes="review-carousel" :items="items" :options="options" :show-navigation="showNavigation">
        <template #slide="{ item }">
            <div class="reviews-slider-item">
                <div class="reviews-slider-item-header">
                    <div class="reviews-slider-item-header-icon" style="background: #03dbe8;">{{ item.author.charAt(0) }}</div>
                    <div class="reviews-slider-item-header-block">
                        <span class="name">{{ item.author }}</span>
                        <div>
                            <span class="date">{{ item.posted_at }}</span>
                            <span v-if="item.city" class="city">{{ item.city }}</span>
                        </div>
                    </div>
                </div>
                <div :ref="`item-${item.id}`" class="reviews-slider-item-content">
                    <div class="reviews-slider-item-content-tags">
                        <span class="item">товар
                            <span>{{ item.product_rate }}</span>
                        </span>
                        <span class="item">сервис
                            <span>{{ item.service_rate }}</span>
                        </span>
                        <span class="item">доставка
                            <span>{{ item.delivery_rate }}</span>
                        </span>
                    </div>
                    <div ref="text" class="reviews-slider-item-content-text">
                        <div ref="inner-text" class="reviews-slider-item-content-text-inner">{{ item.message }}</div>
                    </div>
                    <span v-if="isExpandable(item.id)" class="link link-more" @click.prevent="expandReview(item.id)">Читать полностью</span>
                    <span v-if="isExpandable(item.id)" class="link link-less" @click.prevent="collapseReview(item.id)">Свернуть</span>
                </div>
            </div>
        </template>
    </carousel>
</template>

<script>
import Carousel from "./Carousel";
import windowWidth from "../../mixins/windowWidth";

export default {
    name: "Review",
    props: ['items'],
    components: {
        Carousel,
    },
    mixins: [
        windowWidth
    ],
    data() {
        return {
            textLimit: 119,
            options: {
                spaceBetween: 20,
                loop: true,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                    },
                    640: {
                        slidesPerView: 2,
                    },
                    320: {
                        slidesPerView: 1,
                    }
                },
            },
        }
    },
    computed: {
        showNavigation() {
            return !this.$q.platform.is.mobile
                && !(this.items.length <= 1
                || (this.windowWidth <= 640 && this.items.length <= 2)
                || ((this.windowWidth <= 768 || this.windowWidth > 768) && this.items.length <= 3));
        },
    },
    methods: {
        getItem(id) {
            return _.find(this.items, item => item.id === id);
        },
        isExpandable(id) {
            let item = this.getItem(id);
            if (item) {
                return item.message.length > this.textLimit;
            }
            return false;
        },
        expandReview(id) {
            let element = this.$refs[`item-${id}`];
            if (element) {
                element.classList.add('expanded');
            }
        },
        collapseReview(id) {
            let element = this.$refs[`item-${id}`];
            if (element) {
                element.classList.remove('expanded');
            }
        },
    }
}
</script>

